import React from "react";
import { array, bool, number } from "prop-types";
import { Box } from "@mui/material";

import WrappedProgressIndicator from "../WrappedProgressIndicator";
import RecentUpdatesListItem from "./RecentUpdatesListItem";

import { connectToState } from "../../redux/connect-api";

const RecentUpdates = ({ recentUpdates = [], loading = false, limit = 1 }) => {
  if (loading) {
    return <WrappedProgressIndicator loading={loading} />;
  }

  if (!recentUpdates.length) return null;

  const updates = recentUpdates.filter((item, index) => {
    return limit > 0 ? index < limit : true;
  });

  return (
    <Box
      sx={{
        paddingBottom: "15px",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        maxWidth: "100%",
        boxSizing: "border-box",
      }}
    >
      {updates.map((item, i) => (
        <RecentUpdatesListItem item={item} key={i} last={i === updates.length - 1} />
      ))}
    </Box>
  );
};

RecentUpdates.defaultProps = {
  recentUpdates: [],
  loading: false,
  limit: 1,
};

RecentUpdates.propTypes = {
  recentUpdates: array,
  loading: bool,
  limit: number,
};

const mapStateToProps = (state) => {
  return {
    recentUpdates: state.recentUpdates.data,
    loading: state.recentUpdates.loading,
  };
};

export default connectToState(mapStateToProps)(RecentUpdates);
